@if (translations && item) {
  <div>
    <b>{{ translations.author }}:</b>
    {{ item.lastname || '' }} {{ item.firstname || '' }}

    <hr />

    <h4>{{ translations.description }}</h4>

    <div class="row">
      <div class="col-md-6">
        <p><b>{{ translations.brandName }}:</b> {{ item.brand_name || '' }}</p>
        <p><b>{{ translations.strength }}:</b> {{ item.strength || '' }}</p>
        <p><b>{{ translations.pharmaceuticalDoseForm }}:</b> {{ item.pharmaceutical_dose_form_id || '' }}</p>
        <p><b>{{ translations.packaging }}:</b> {{ item.package_num || '' }} × ({{ item.package_type_id || '' }})</p>
      </div>

      <div class="col-md-6">
        <p><b>{{ translations.atcCode }}:</b> {{ item.active_ingredient_id || '' }}</p>
        <p><b>{{ translations.activeSubstance }}:</b> {{ item.active_ingredient || '' }}</p>
        <p><b>{{ translations.substitutionAllowed }}:</b> {{ item.substitution || '' }}</p>
      </div>
    </div>

    <hr />

    <h4>{{ translations.treatment }}</h4>

    <div class="row">
      <div class="col-md-6">
        <p><b>{{ translations.quantity }}:</b> {{ item.quantity || '' }} {{ item.number_of_units_per_intake || '' }}</p>
        <p><b>{{ translations.frequency }}:</b> EVERY {{ item.frequency_of_intake || '' }} {{ item.frequency_of_intake_unit_description || '' }}</p>
        <p><b>{{ translations.route }}:</b> {{ item.route_of_administration_id || '' }}</p>
        <p><b>{{ translations.advices }}:</b> {{ item.instructions_to_dispencer || '' }}</p>
      </div>

      <div class="col-md-6">
        <p><b>{{ translations.duration }}:</b> {{ item.duration || '' }} {{ item.duration_unit || '' }}</p>
        <p><b>{{ translations.onsetDate }}:</b> {{ formatDate(item.date_of_onset) }}</p>
        <p><b>{{ translations.expiryDate }}:</b> {{ item.expiry_date || '' }}</p>
        <p><b>{{ translations.instructions }}:</b> {{ item.instructions_to_patient || '' }}</p>
      </div>
    </div>

    @if (isDispensed()) {
      <hr />

      <h4>{{ translations.dispensationInformation }}</h4>

      <div class="row">
        <div class="col-md-6">
          <p><b>{{ translations.brandName }}:</b> {{ item.extra_info?.brand_name || '' }}</p>
          <p><b>{{ translations.atcCode }}:</b> {{ item.extra_info?.atc_code || '' }}</p>
          <p><b>{{ translations.strength }}:</b> {{ item.extra_info?.strength || '' }}</p>
          <p><b>{{ translations.packaging }}:</b> {{ item.extra_info?.packaging || '' }}</p>
          <p><b>{{ translations.numberOfPackages }}:</b> {{ item.extra_info?.package_num || '' }}</p>
          <p><b>{{ translations.pharmaceuticalDoseForm }}:</b> {{ item.extra_info?.pharmaceutical_dose_form || '' }}</p>
          <p><b>{{ translations.routeOfAdministration }}:</b> {{ item.extra_info?.route_of_administration || '' }}</p>
          <p><b>{{ translations.substitution }}:</b> {{ item.extra_info?.substitution || '' }}</p>
        </div>

        <div class="col-md-6">
          <p><b>{{ translations.dispensationDate }}:</b> {{ formatDate(item.extra_info?.date_of_dispense) }}</p>
          <p><b>{{ translations.countryOfDispensation }}:</b> {{ item.extra_info?.dispenser_country || '' }}</p>
          <p><b>{{ translations.pharmacistName }}:</b> {{ item.extra_info?.dispenser_name_surname || '' }}</p>
          <p><b>{{ translations.pharmacistTelephone }}:</b> {{ item.extra_info?.dispenser_telephone || '' }}</p>
          <p><b>{{ translations.organization }}:</b> {{ item.extra_info?.represented_organization_name || '' }}</p>
        </div>
      </div>
    }
  </div>
}
